import RequestSpin from "slotworks/state-machine/standard/states/request-spin";
import HarleyComponents from "components/components";
import { StaticSymbolsCommand } from "slotworks/commands/symbols/static-symbols-command";
import soundManager from "slotworks/sound/sound-manager";

export default class HarleyRequestSpin extends RequestSpin {

    public onEnter(cascadeSkip?: boolean): void {
        HarleyComponents.bonusBuyButton.setEnabled(false);
        StaticSymbolsCommand().execute();
        super.onEnter(cascadeSkip);
    }

    public error() {
        soundManager.customEvent("reel_transition_end");
        HarleyComponents.reelAnimations.stop();
        HarleyComponents.quickHit.stop();
        HarleyComponents.quickHit.stopSpin();
        super.error();
    }

}